/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na informace o skryté virtuální klávesnici.
 */
class VirtualKeyboardHiddenFactory {
  /**
   * @param {Class.<VirtualKeyboardHidden>} VirtualKeyboardHidden
   */
  constructor(VirtualKeyboardHidden) {
    this.VirtualKeyboardHidden = VirtualKeyboardHidden;
  }

  /**
   * @returns {VirtualKeyboardHidden}
   */
  create() {
    return new this.VirtualKeyboardHidden();
  }
}

export default VirtualKeyboardHiddenFactory;
